var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{staticClass:"textarea-ref",attrs:{"label":_vm.labelComputed,"value":_vm.safeValue,"rows":_vm.rowsComputed,"dense":"","outlined":"","readonly":"","auto-grow":"","no-resize":_vm.noResize}})}
var staticRenderFns = []

export { render, staticRenderFns }